import { HttpMethodEnum } from "../data/models/HttpMethodEnum";
import { ApiResponse, RequestBuilder } from "./RequestBuilder";

export class BaseApi {
  protected static requestBuilder = new RequestBuilder();

  protected static createEndpoint<ResponseType, ParamsType>(
    method: HttpMethodEnum,
    url: string
  ) {
    return {
      request: (params: ParamsType): Promise<ApiResponse<ResponseType>> =>
        BaseApi.requestBuilder.requestWithCache<ResponseType>(
          method,
          url,
          params
        ),

      requestHard: (params: ParamsType): Promise<ApiResponse<ResponseType>> =>
        BaseApi.requestBuilder.requestHard<ResponseType>(method, url, params),
    };
  }
}
